const RELATES_TO_PREFIX = 'שייך לנכס ';
const SOLD_MARKER = 'נמכר ב';

export function stripRelatesToFromDescription(desc) {
    if (!desc || typeof desc !== 'string') return '';
    let beforeSold = desc;
    let soldPart = '';
    const soldIdx = desc.indexOf(SOLD_MARKER);
    if (soldIdx >= 0) {
        beforeSold = desc.substring(0, soldIdx).trimEnd();
        soldPart = desc.substring(soldIdx).trim();
    }
    const relatesIdx = beforeSold.indexOf(RELATES_TO_PREFIX);
    const cleaned = relatesIdx >= 0 ? beforeSold.substring(0, relatesIdx).trimEnd() : beforeSold;
    return soldPart ? `${cleaned} ${soldPart}`.trim() : cleaned;
}

export function stripSoldOn(desc = '') {
    if (!desc) return '';
    const soldIndex = desc.indexOf(SOLD_MARKER);
    if (soldIndex < 0) return desc.trim();
    let result = desc.substring(0, soldIndex).trimEnd();
    if (result.endsWith(' -')) {
        result = result.slice(0, -2).trimEnd();
    }
    return result;
}

export function appendRelatesToDescription(base, assetName) {
    let beforeSold = base || '';
    let soldPart = '';
    const soldIdx = (base || '').indexOf(SOLD_MARKER);
    if (soldIdx >= 0) {
        beforeSold = base.substring(0, soldIdx).trimEnd();
        soldPart = base.substring(soldIdx).trim();
    }
    const relatesIdx = beforeSold.indexOf(RELATES_TO_PREFIX);
    const cleaned = relatesIdx >= 0 ? beforeSold.substring(0, relatesIdx).trimEnd() : beforeSold;
    const relatesPart = `${RELATES_TO_PREFIX}${assetName}`;
    const withRelates = cleaned ? `${cleaned} ${relatesPart}` : relatesPart;
    return soldPart ? `${withRelates} ${soldPart}`.trim() : withRelates;
}
